import {
  SHOPCATEGORY_FETCHING,
  SHOPCATEGORY_FAILED,
  SHOPCATEGORY_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SHOPCATEGORY_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case SHOPCATEGORY_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case SHOPCATEGORY_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
